import React from "react"
import { useSelector } from "react-redux"

import Images from "assets/images"
import { StoreType } from "client/store"
import { Logo, Input } from "client/components"

import {
    ModelWrapper,
    ModelNestedWrapper,
    BlockWrapper,
    Block,
    BlockInputWrapper,
    ModelSil,
} from "client/pages/sil/modelStyled"

import { getSilDeviceTitle, getModelSil } from "client/pages/sil/formulas"
import Settings from "./settings"

const Model = () => {
    const safetyFunction = useSelector((state: StoreType) => state.silSafetyFunction.safetyFunctionView)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    // important! get the subsystem list from the function!
    const subsystemList = safetyFunction.subsystems || []

    return (
        <ModelWrapper direction="column">
            <ModelNestedWrapper>
                {
                    subsystemList.map((subsystem) => (
                        <BlockWrapper key={subsystem.id} type="function">
                            <BlockInputWrapper>
                                <Input type="text" value={subsystem.architecture} readOnly />
                                <Input type="text" value={subsystem.name} readOnly />
                            </BlockInputWrapper>

                            {
                                subsystem.blocks.map((block) => ([
                                    <Block
                                        key="block"
                                        title={getSilDeviceTitle(block.projectDevice, moduleList, lang)}
                                    >
                                        {
                                            block && block.projectDevice && (
                                                <Logo
                                                    size={100}
                                                    logo={
                                                        block.projectDevice.logo
                                                        || (block.projectDevice.qidProductId ? Images.qidProductLogo : Images.silDeviceLogo)
                                                    }
                                                />
                                            )
                                        }
                                    </Block>,
                                    <ModelSil key="sil">
                                        {
                                            block
                                            && block.projectDevice
                                            && getModelSil(block.projectDevice, subsystem.architecturalConstraints, lang)
                                        }
                                    </ModelSil>,
                                ]))
                            }
                        </BlockWrapper>
                    ))
                }
            </ModelNestedWrapper>

            <Settings />
        </ModelWrapper>
    )
}
export default Model
